import { useEffect } from "react";

export const useScrollLock = (isLocked) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;

    if (isLocked) {
      document.body.style.overflow = "hidden"; // lock scroll
    } else {
      document.body.style.overflow = originalStyle; // restore scroll
    }

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isLocked]);
};
